module.exports = __webpack_public_path__ + "static/media/service3.d9285b53.svg";